import { Box, FlexBox, Page } from '@dixa/lib-shared-habla';

export const GuideSection = (): JSX.Element => {
  return (
    <Page.Section title="Set up your Jabra devices to accept / reject calls">
      <FlexBox
        as="ul"
        padding="100 0 0 400"
        margin="0 0 0 0"
        gap="200"
        flexDirection="column"
        style={{ listStyleType: 'number' }}
      >
        <Box as="li">Connect your Jabra device via USB.</Box>
        <Box as="li">Press the &quot;add device&quot; button.</Box>
        <Box as="li">
          Select your device in the popup that appears, and press
          &quot;Connect&quot;.
        </Box>
      </FlexBox>
    </Page.Section>
  );
};
